<template>
  <div class="pc-page">
    <div class="top-wrap">
      <div class="top">
        <img class="logo" src="./../../../assets/png/pc/logo.png" alt="">
        <img class="cdn" src="./../../../assets/png/pc/cdn.png" alt="">
      </div>
    </div>

    <div class="container">

      <div class="app-list">
        <div :class="['item', 'item' + index]" v-for="(item, index) in urlList" :key="index"
          @click="tolinkUrl(item.url)"></div>
      </div>
      <div class="title">推荐应用</div>
      <div class="app-list1">
        <div :class="['item', 'item' + index]" v-for="(item, index) in urlList1" :key="index"
          @click="tolinkUrl(item.url)"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mobile",
  data() {
    return {
      urlList: [
        { name: '海角乱伦', url: 'https://d2f766ao25clj9.cloudfront.net/' },
        { name: '欲漫涩', url: 'https://d1cvba6jjnyrz8.cloudfront.net' },
        { name: 'pornhub中文版', url: 'https://d10laclvwsb8co.cloudfront.net/' },
        { name: '萝莉岛', url: 'https://d2waroz71jry9f.cloudfront.net' },
        { name: '好色', url: 'https://d3c443ud8xfqql.cloudfront.net/' },
        { name: '麻豆', url: 'https://d1ot4pygight2l.cloudfront.net' },
        { name: '萝莉岛2', url: 'https://d3tlm0h7sabwzr.cloudfront.net' },
        { name: 'xvideos', url: 'https://d1t02k8k72gbtg.cloudfront.net/' },
        { name: 'tiktok成人版', url: 'https://dw42outgvsfe2.cloudfront.net/' },
        { name: '91暗网', url: 'https://d2ks0z1oyk6g72.cloudfront.net/' },
        { name: '妻友', url: 'https://d2fu51xu2j8prl.cloudfront.net' },
        { name: '妖精动漫', url: 'https://d16bvop3am72su.cloudfront.net/' },
        { name: '逼哩逼哩', url: 'https://dyjy48nhs2tuv.cloudfront.net' },
        { name: '黑料社', url: 'https://d2tvuhdqpq6iwx.cloudfront.net/' },
        { name: 'pornhub精品版', url: 'https://d1212e29t5rkup.cloudfront.net' },
        { name: '91猎奇', url: 'https://d2snc9wctscip8.cloudfront.net' },
      ],
      urlList1: [
        { name: 'bili短视频', url: 'https://d3a46qy1eune4j.cloudfront.net/' },
        { name: '涩漫天堂', url: 'https://d2xggahr3zdjh7.cloudfront.net' },
        { name: '暗网禁地', url: 'https://d18fj45mwgyd3u.cloudfront.net/' },
        { name: '波多', url: 'https://d3544cqb5ks2vv.cloudfront.net' },
        { name: '哆哔涩漫', url: 'https://dcv18krkd3b78.cloudfront.net/' },
        { name: '快手', url: 'https://d4ydczzq5z5fx.cloudfront.net' },
        { name: '好色姐姐', url: 'https://d37g2dq65n5eeu.cloudfront.net' },
        { name: '51乱伦', url: 'https://d10w89bb8pybjv.cloudfront.net/' },
        { name: '腾讯涩漫', url: 'https://d25o6ttz01s0jh.cloudfront.net/' },
        { name: '91涩漫', url: 'https://dbdefw2ir86ni.cloudfront.net' },
        { name: '呦乐园', url: 'https://dkddri3585nsw.cloudfront.net/' },
        { name: '极乐禁地  ', url: 'https://d23daxj6iy7wd6.cloudfront.net' },
        { name: '糖心视频', url: 'https://d28mbzbtfe04p2.cloudfront.net' },
        { name: '泡芙视频 ', url: 'https://dl1p3v4djoxfw.cloudfront.net/' },
        { name: 'ONE一个', url: 'https://d1odmsnakii7fd.cloudfront.net/' },
      ]
    }
  },
  methods: {
    tolinkUrl(url) {
      const dc = process.env.VUE_APP_WEB_DC || 985
      window.open(url + '?dc=' + dc);
    }
  }
};
</script>
<style lang="scss" scoped>
.pc-page {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: url('./../../../assets/png/pcbg.webp') center;
  background-size: cover;
  .top-wrap {
    background: #1A1A1A;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
    height: 78PX;
    margin-bottom: 24px;
  }
  .top {
    width: 1265PX;
    height: 78PX;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    .logo {
      width: 140PX;
      height: 40PX;
    }

    .cdn {
      width: 176PX;
      height: 42PX;
    }
  }
  .container {
    width: 1265PX;
    height: 100%;
    margin: auto;
  }

  .app-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 14PX;

    .item {
      width: 145PX;
      height: 224PX;
      cursor: pointer;
      transform: scale(1);
      transition: all 0.5s;
    }

    .item:hover {
      transform: scale(1.05);
      transition: all 0.5s;
    }

    @for $i from 0 through 15 {
      .item#{$i} {
        background: url('./../../../assets/png/pc/img/#{$i}.png');
        background-size: 100% 100%;
      }
    }
  }

  .title {
    color: #fff;
    font-size: 24PX;
    font-weight: 500;
    line-height: 34PX;
    margin-top: 30PX;
    margin-bottom: 21PX;
  }

  .app-list1 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 14PX;

    .item {
      width: 410PX;
      height: 96PX;
      cursor: pointer;
      transform: scale(1);
      transition: all 0.4s;
    }

    .item:hover {
      transform: scale(1.03);
      transition: all 0.4s;
    }

    @for $i from 0 through 14 {
      .item#{$i} {
        background: url('./../../../assets/png/pc/img1/#{$i}.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>
